import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { Info } from '@/components/ui/Info'
import { Modal } from '@/components/ui/Modal'
import { useRouteStore } from '@/store/route'
import { useSnackbarStore } from '@/store/snackbar'
import { StandardDonationStateAction } from '@types'
import { useState } from 'react'

interface ArrivedButtonProps {
  donationId: number
  /** Icon-only round button for collapsed state */
  iconOnly?: boolean
  disabled?: boolean
  className?: string
}

export const ArrivedButton = ({
  donationId,
  iconOnly = false,
  disabled = false,
  className,
}: ArrivedButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const updateDonationState = useRouteStore(
    (state) => state.updateDonationState
  )
  const showSnackbar = useSnackbarStore((state) => state.show)

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      await updateDonationState(donationId, {
        state_action: StandardDonationStateAction.ARRIVE,
      })
      setIsModalOpen(false)
      showSnackbar('Status updated to Arrived', 'success')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {iconOnly ? (
        <Button
          icon={<Icon name="check" />}
          variant="primary"
          rounded
          onClick={() => setIsModalOpen(true)}
          disabled={disabled}
          className={className}
          testId="arrived-button-icon"
        />
      ) : (
        <Button
          text="Arrived"
          variant="primary"
          icon={<Icon name="check" size={16} />}
          onClick={() => setIsModalOpen(true)}
          disabled={disabled}
          className={className}
          testId="arrived-button"
        />
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Arrived to pickup location?"
        buttonLayout="column"
        testId="arrived-modal"
        buttons={[
          <Button
            key="arrived"
            text="Yes, I arrived"
            variant="primary"
            onClick={handleConfirm}
            loading={isLoading}
            testId="arrived-modal-confirm"
          />,
          <Button
            key="back"
            text="Go back"
            variant="default"
            onClick={() => setIsModalOpen(false)}
            testId="arrived-modal-back"
          />,
        ]}
      >
        <Info>The donor will be notified you have arrived</Info>
      </Modal>
    </>
  )
}
